// UI strings for Peterson's model clip of a single form when it was cut out of his recording of a
// whole line (src/formvoices/models.ts, npm run peterson:cuts). Finnish (default) and English side
// by side. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const formModelsFi = {
  /** Under the model clip's button; the line follows in High Valyrian. */
  fromLine: 'Leikattu Petersonin lauseesta',
  /** The button's accessible name, e.g. "Kuuntele: kostas (Petersonin lauseesta)". */
  cutName: (hv: string) => `${hv} (Petersonin lauseesta)`,
};

export type FormModelsMessages = typeof formModelsFi;

export const formModelsEn: FormModelsMessages = {
  fromLine: 'Cut from Peterson’s sentence',
  cutName: (hv) => `${hv} (from Peterson’s sentence)`,
};

// Messages.formModels (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('formModels', formModelsFi, formModelsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof formModelsFi> {}
}
